import React, { useState, useEffect, useRef } from 'react';
import Logo from './../../components/logo.webp';
import './../../styles/user/dieta.css';
import * as globals from './../../components/GlobalScripts.js';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const User_dieta = () => {
  const [dieta, setDieta] = useState({});
  const [nombre, setNombre] = useState('');
  const [coachName, setCoachName] = useState('Daniel Méndez');
  
  const dietaRef = useRef(null);

  useEffect(() => {
    get_diet();
  }, []);

  const get_diet = () => {
    globals.validateSession();
    globals.openViewCharge();
    const user = globals.get_user();
    let json_info = {};
    let dietaLocal = {};

    setNombre(user.nombre);

    if (user.json_info)
      json_info = user.json_info;

    if (json_info.dieta)
      dietaLocal = json_info.dieta;

    if (dietaLocal)
      setDieta(dietaLocal);

    globals.closeViewCharge();
  };

  const handleDownloadPDF = async () => {
    globals.openViewCharge();
    try {
      document.getElementById('pdfLogoContainer').style.display = 'flex';
      document.getElementById('pdfCoachName').style.display = 'block';

      const element = dietaRef.current;
      const canvas = await html2canvas(element, {
        backgroundColor: '#000',
      });

      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'px',
        format: 'a4'
      });

      const pageWidth  = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const canvasWidth  = canvas.width;
      const canvasHeight = canvas.height;

      const imgWidth  = pageWidth;
      const imgHeight = (canvasHeight * imgWidth) / canvasWidth;

      const imgData = canvas.toDataURL('image/png', 1.0);

      let heightLeft = imgHeight;
      let position = 0;

      pdf.setFillColor(0, 0, 0);
      pdf.rect(0, 0, pageWidth, pageHeight, 'F');

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        pdf.addPage();
        pdf.setFillColor(0, 0, 0);
        pdf.rect(0, 0, pageWidth, pageHeight, 'F');

        position = heightLeft - imgHeight;
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save('Dieta.pdf');

      document.getElementById('pdfLogoContainer').style.display = 'none';
      document.getElementById('pdfCoachName').style.display = 'none';

      setTimeout(() => {
        globals.closeViewCharge();
      }, 1000);

    } catch (error) {
      globals.createAlert({
        type: "error",
        msg_title: "Error",
        msg: "No se generó el PDF",
        effect: "opacidad 2s, desplazamiento 2s",
        time_life: 4000
      });
      globals.closeViewCharge();
    }
  };

  return (
    <div className="page-dieta container-section flex-column gap-20">
      <div className='container-button-sticky flex-row justify-end'>
        <span className="button-primary" onClick={handleDownloadPDF}>
          Descargar
        </span>
      </div>

      <div
        ref={dietaRef}
        style={{
            backgroundColor: 'var(--color-black)',
            padding: 'var(--var-padding-20)'
        }}
      >
        <div
          className='flex-row center'
          id='pdfLogoContainer'
          style={{ display: 'none' }}
        >
            <img src={Logo} className='img-logo' alt="Logo" />
        </div>

        <h1>Plan alimenticio de {nombre}</h1>

        <h5 id="pdfCoachName" style={{ display: 'none' }}>
            Coach: {coachName}
        </h5>

        {Object.keys(dieta).length > 0 ? (
          Object.entries(dieta).map(([title, opts]) => (
            <div key={title} className="diet-section">
              <h2 className='no-margin'>{title}</h2>
              {opts.length > 0 ? (
                <ul>
                  {opts.map((opt, index) => (
                    <li key={index}>
                      {opt}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>
                  No hay dieta para esta opción.
                </p>
              )}
            </div>
          ))
        ) : (
          <p>
            De momento no hay dieta para mostrar, vuelve más tarde.
          </p>
        )}
      </div>
    </div>
  );
};

export default User_dieta;
